module.exports = __webpack_public_path__ + "img/img_point_def_40f22e1a5.png";